import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { SessionService } from 'src/app/shared/_service/session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-import-excel',
	templateUrl: './import-excel.component.html',
})
export class ImportExcelComponent implements OnInit {
	constructor(
		private api: ApiService,
		private session: SessionService,
		private modalService: NgbModal,
	) {}

	@ViewChild('hiddenfileinput', { static: false }) hiddenfileinput: any;

	segnalazioni = [];

	dtOptions = { paging: false, searching: false };

	ngOnInit() {}

	upload(fileEvent: any, content) {
		const file = fileEvent.target.files.item(0);
		if (!file) {
			return;
		}
		this.api.importTemplate(file).subscribe((messages) => {
			this.hiddenfileinput.nativeElement.value = null;
			this.segnalazioni = [];

			this.session.updateCarrello();
			if (messages) {
				messages.split(';').forEach((message) => {
					const segments = message.split('#');
					if (segments.length > 0 && segments[1]) {
						this.segnalazioni.push({
							message: segments[0],
							codice: segments[1],
							riga: segments[2],
							isError: segments[0] !== 'prodotto.inserito',
						});
					}
				});
			}

			this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(() => {});
		});
	}

	download() {
		this.api.getTemplate().subscribe((blob) => {
			const URL = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = URL;
			a.download = 'Template.xlsx';
			a.click();
			window.URL.revokeObjectURL(URL);
			a.remove();
		});
	}
}
